import { Table } from '@mantine/core'
import { Typography } from '../../common/typography'
import classes from './Breakdown.module.css'
import { BreakdownData } from './api'

export default function TotalPointsBreakdown({
  data,
}: {
  data: BreakdownData
}) {
  return (
    <div>
      <Table
        classNames={{
          table: classes.table,
          tr: classes.tr,
          th: classes.th,
          td: classes.td,
        }}
        verticalSpacing="xs"
        withRowBorders={false}
        highlightOnHover
      >
        <Table.Thead className={classes.table_head}>
          <Table.Tr className={classes.headerRow}>
            <Table.Th>
              <Typography
                fw={500}
                fc={{ light: 'black', dark: 'black' }}
                lh="100"
              >
                Breakdown
              </Typography>
            </Table.Th>
            <Table.Th>
              <Typography
                fw={500}
                fc={{ light: 'black', dark: 'black' }}
                lh="100"
                ta="center"
              >
                Points
              </Typography>
            </Table.Th>
            <Table.Th>
              <Typography
                fw={500}
                fc={{ light: 'black', dark: 'black' }}
                lh="100"
                ta="right"
              >
                Max
              </Typography>
            </Table.Th>
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>
          <Table.Tr>
            <Table.Td>
              <Typography fc={{ light: 'black', dark: 'gray-3' }} lh="150">
                KPI
              </Typography>
            </Table.Td>
            <Table.Td>
              <Typography
                fc={{ light: 'black', dark: 'gray-3' }}
                ff="JetBrains Mono"
                fw={500}
                lh="150"
                ta="center"
              >
                {data.month.points}
              </Typography>
            </Table.Td>
            <Table.Td>
              <Typography
                fc={{ light: 'black', dark: 'gray-3' }}
                ff="JetBrains Mono"
                fw={500}
                lh="150"
                ta="right"
              >
                {data.month.max_points}
              </Typography>
            </Table.Td>
          </Table.Tr>
          <Table.Tr>
            <Table.Td>
              <Typography fc={{ light: 'black', dark: 'gray-3' }} lh="150">
                League
              </Typography>
            </Table.Td>
            <Table.Td>
              <Typography
                fc={{ light: 'black', dark: 'gray-3' }}
                ff="JetBrains Mono"
                fw={500}
                lh="150"
                ta="center"
              >
                {data.round.points}
              </Typography>
            </Table.Td>
            <Table.Td>
              <Typography
                fc={{ light: 'black', dark: 'gray-3' }}
                ff="JetBrains Mono"
                fw={500}
                lh="150"
                ta="right"
              >
                {data.round.max_points}
              </Typography>
            </Table.Td>
          </Table.Tr>
          <Table.Tr>
            <Table.Td>
              <Typography fc={{ light: 'black', dark: 'gray-3' }} lh="150">
                Learning XP
              </Typography>
            </Table.Td>
            <Table.Td>
              <Typography
                fc={{ light: 'black', dark: 'gray-3' }}
                ff="JetBrains Mono"
                fw={500}
                lh="150"
                ta="center"
              >
                {data.bonus.points}
              </Typography>
            </Table.Td>
            <Table.Td>
              <Typography
                fc={{ light: 'black', dark: 'gray-3' }}
                ff="JetBrains Mono"
                fw={500}
                lh="150"
                ta="right"
              >
                {data.bonus.max_points}
              </Typography>
            </Table.Td>
          </Table.Tr>
        </Table.Tbody>
        <Table.Tfoot className={classes.table_head}>
          <Table.Tr className={classes.headerRow}>
            <Table.Th>
              <Typography
                fw={500}
                fc={{ light: 'black', dark: 'black' }}
                lh="100"
              >
                Total
              </Typography>
            </Table.Th>
            <Table.Th>
              <Typography
                fw={500}
                fc={{ light: 'black', dark: 'black' }}
                ff="JetBrains Mono"
                lh="150"
                ta="center"
              >
                {data.total_points}
              </Typography>
            </Table.Th>
            <Table.Th>
              <Typography
                fw={500}
                fc={{ light: 'black', dark: 'black' }}
                ff="JetBrains Mono"
                lh="150"
                ta="right"
              >
                {data.month.max_points +
                  data.round.max_points +
                  data.bonus.max_points}
              </Typography>
            </Table.Th>
          </Table.Tr>
        </Table.Tfoot>
      </Table>
    </div>
  )
}
